<template>
	<v-row justify="center">
		<v-dialog v-model="saveDialog.dialog" persistent max-width="400">
			<v-card>
				<v-card-title class="headline">Сохранение коцепции</v-card-title>
				<v-card-text>
					<v-text-field
						label="Название концепции"
						v-model="saveDialog.editableConcept"
					></v-text-field>
				</v-card-text>
				<v-card-actions>
					<div class="flex-grow-1"></div>
					<v-btn
						:disabled="!saveDialog.editableConcept.length"
						color="success"
						text
						@click="saveConcept"
					>Сохранить
					</v-btn>
					<v-btn color="error" text @click="dontSave">Не сохранять</v-btn>
					<v-btn text @click="saveDialog.dialog = false">Отмена</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
  export default {
    name: "SaveDialog",
    props: {
      saveDialog: Object,
      concept: String,
      saveConcept: Function,
      changeIsNotSaved: Function,
      changePage: Function,
    },
    methods: {
      dontSave: function () {
        this.saveDialog.dialog = false;
        this.changeIsNotSaved(false);
        if (this.saveDialog.nextRoute) this.changePage(this.saveDialog.nextRoute);
      }
    },
  }
</script>

<style scoped>

</style>